import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageSquare, Linkedin, Instagram, Youtube, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { aboutMeContent } from '../data/aboutMe';

const Footer = () => {
  const { t } = useTranslation();
  
  const iconMap = {
    linkedin: Linkedin,
    instagram: Instagram,
    youtube: Youtube,
    workana: ExternalLink,
    upwork: ExternalLink,
    drive: ExternalLink,
    mail: Mail
  };

  const socialLinksFiltered = aboutMeContent.socialLinks.filter(
    link => ['linkedin', 'instagram', 'youtube', 'workana'].includes(link.icon)
  );
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column footer-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_ef7f9068-c57a-47e6-a371-0c0ce29395f2/artifacts/1i1z9m57_1709051552458.png" 
              alt="LPF Data Analytics" 
              className="footer-logo"
            />
            <p className="footer-tagline">
              {t('footer.tagline')}
            </p>
          </div>

          <div className="footer-column">
            <h3 className="footer-heading">{t('footer.company')}</h3>
            <ul className="footer-links">
              <li>
                <Link to="/" className="footer-link">{t('nav.home')}</Link>
              </li>
              <li>
                <Link to="/portfolio" className="footer-link">{t('nav.portfolio')}</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link">{t('nav.services')}</Link>
              </li>
              <li>
                <Link to="/blog" className="footer-link">{t('nav.blog')}</Link>
              </li>
              <li>
                <Link to="/about-me" className="footer-link">{t('nav.about')}</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-heading">{t('footer.socialMedia')}</h3>
            <ul className="footer-links">
              {socialLinksFiltered.map((link, index) => {
                const Icon = iconMap[link.icon] || ExternalLink;
                return (
                  <li key={index}>
                    <a 
                      href={link.url} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="footer-link footer-link-icon"
                    >
                      <Icon size={16} />
                      {link.platform}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-heading">{t('footer.getInTouch')}</h3>
            <ul className="footer-links">
              <li>
                <a href="mailto:lpfdataanalytics@gmail.com" className="footer-link footer-link-icon">
                  <Mail size={18} />
                  lpfdataanalytics@gmail.com
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/5588996527079" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-link footer-link-icon"
                >
                  <MessageSquare size={18} />
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} {t('footer.copyright')}
          </p>
          <div className="footer-bottom-links">
            <a href="/privacy" className="footer-link-small">{t('footer.privacy')}</a>
            <a href="/terms" className="footer-link-small">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
